;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Layout = APP.module('Layout');
	var Collection = APP.module('Collection');
	var Model = APP.module('Model');
	var Controller = APP.module('Controller');
	var Router = APP.module('Router');

	Layout.Header = Marionette.LayoutView.extend({
		template: JST.header,
		ui: {
			cog: '#user-account-menu',
			open: '#js-menu-icon',
			close: '#js-overlay',
			back: '#js-history-go-back',
			page_wrapper: '.main-outer',
			mobile_menu: '#mobile-menu',
			swipe_body: 'body',
			close_game_redirect: '.js-closed-item'
		},
		events: {
			'click @ui.cog': 'toggleSubMenu',
			'click @ui.open': 'toggleMobileMenu',
			'click @ui.close': 'toggleMobileMenu',
			'click @ui.back': 'backState',
			'click @ui.close_game_redirect': 'closeGameRedirect'
		},
		site_title: 'Base Header',
		initialize: function() {
			this.collection = this.options.menuItems;
			this.subMenuItems = this.options.subMenuItems;
			this.user = APP.module('instance').user;
			this.model.set({
				showMainMenu: false,
				showRightMenu: false,
				project_name: CONFIG.IMAGES_URL,
				state: this.state,
				is_off_season: CONFIG.OFF_SEASON
			});

			this.customInitAdder();

			return this.listenEvt().updateModel();
		},
		listenEvt: function() {
			this.listenTo(APP.vent, 'route:change', this.setState);
			this.listenTo(this.user, 'change:session_id', this.render);
			this.listenTo(this.user, 'change', this.render);
			this.listenTo(APP.vent, 'show:menu', this.beforeRenderAction);
			this.listenTo(APP.vent, 'header:login:re-render', this.beforeRenderAction);
			this.listenTo(APP.vent, 'show:menu', this.onShowMenu);
			this.listenTo(APP.vent, 'header:re-render', this.render);

			return this;
		},
		bindUIElements: function() {
			_.each(this.ui, function(ui, key) {
				this.ui[key] = $(ui);
			}, this);

			return this;
		},

		beforeRenderAction: function() {

			this.updateModel();
			APP.vent.trigger('header:re-render');
			APP.vent.trigger('mobile_menu:close');

		},

		updateModel: function() {

			this.model.set({
				items: this.collection.toJSON(),
				user: this.user.toJSON(),
				subMenuItems: this.subMenuItems.toJSON(),
				title: this.site_title,
				showLeftMenu: true,
				showMobileMenu: true
			});

			return this;
		},
		setState: function(state, args) {
			this.state = state;

			this.collection.selectActiveState(state);

			if (!this.user.id) {
				this.model.set({
					state: this.state
				});
				this.render();
			}

			return this;
		},
		backState: function() {
			Backbone.history.history.back();
		},
		toggleSubMenu: function() {
			$('.user-account-menu').toggleClass('hidden visible-block');
		},
		toggleMobileMenu: function(e) {

			this.toggleMenuClass();
			return this;
		},
		toggleMenuClass: function() {

			this.ui.page_wrapper.toggleClass("open-menu")
				.addClass('close-menu')
				.delay(700)
				.queue(function() {
					$(this).removeClass('close-menu');
					$(this).dequeue();
				});

		},
		filterMenuCollection: function(collection) {
			return _.where(
				_.map(collection, function(val) {
						val.submenu = _.where(val.submenu, { available: true });
						return val;
					}
				), { available: true });
		},
		closeGameRedirect: function() {

			APP.vent.trigger('popup:message:show', "Coming soon!");

			return this;
		},
		customInitAdder: function() {
			return this;
		},

		getSubMenuItems() {
			const menu_items = this.subMenuItems.toJSON();

			_.each(menu_items, menu_item => {
				menu_item.path = '#' + menu_item.path
			});

			return menu_items
		}
	});


}(window, APP, Backbone, Marionette, $, _));
